import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    resources: {
      en: {
        translation: {
          welcome: "Welcome",
          changeLanguage: "Change Language",
          visit_the_website: "Visit The website",

          registration_form: "Registration Form",
          adentalis: "ADENTALIS",
          visitor_information: "Visitor Information",
          first_name: "First Name",
          first_name_is_required: "First Name is Required",
          last_name: "Last Name",
          last_name_is_required: "Last Name is Required",
          work_address: "Work Address",
          work_address_is_required: "Address is Required",
          academic_level: "Academic Level",
          please_select_one_of_academic_level: "Please Select One Of Academic Level",
          specialization: "Specialization",
          // specialization_is_required: "Specialization is Required",
          contact_information: "Contact Information",
          country: "Country",
          country_is_required: "Country is Required",
          city: "City",
          city_is_required: "City is Required",
          landline_phone: "Landline Phone",
          // landline_phone_is_required: "Landline Phone is Required",
          mail: "Mail",
          please_enter_a_valid_mail: "Please Enter a Valid Mail (e.g. example@domain.com)",
          phone_number_is_required: "Phone Number is Required",
          fields_of_medical_interest: "Fields Of Medical Interest",
          medical_interests: "Medical Interests",
          please_select_at_least_one_area_of_interest: "Please Select at Least One Area Of Interest",
          other_interest: "Other Interest",
          how_did_you_hear_about_us: "How Did You Hear About Us",
          heard_about_us: "Heard About Us",
          please_select_one_of_how_did_you_hear_about_us: "Please Select One Of How Did You Hear About Us",
          other_hear_about_us: "Other Methods",
          other_heard_about_us_is_required : "Other Heard About Us is Required",
          please_check_your_email: "Please Check Your Email",
          submit: "Submit",
          submitting: "Submitting",
          who_are_we: "Who Are We",
          description: "It is a British academy specialized in dentistry, leading the way in shaping the future of medical education through high-quality, evidence-based practical training programs.",
          contact_us: "Contact Us",
          location: "Damascus, Syria",
          copyright: "Copyright",
          developed: "Developed By AIGate. All Rights Reserved",
          events: "Events",
          please_select_at_least_one_of_events: "Please Select at Least One Of Events",
          start_time: "Start Time",
          end_time: "End Time",
          event_location: "Event Location",
          price: "Price",

        }
      },
      ar: {
        translation: {
          welcome: "أهلا بك",
          changeLanguage: "تغيير اللغة",
          visit_the_website: "زيارة الموقع الرسمي",

          registration_form: "استمارة التسجيل",
          adentalis: " ادينتاليس",
          visitor_information: "معلومات الزائر",
          first_name: "الاسم الاول",
          first_name_is_required: "الاسم الاول مطلوب",
          last_name: "الاسم الاخير",
          last_name_is_required: "الاسم الاخير مطلوب",
          work_address: "مكان العمل",
          work_address_is_required: "مكان العمل مطلوب",
          academic_level: "المستوى العلمي",
          please_select_one_of_academic_level: "الرجاء اختيار المستوى العلمي",
          specialization: "الاختصاص",
          // specialization_is_required: "الاختصاص مطلوب",
          contact_information: "معلومات التواصل",
          country: "الدولة",
          country_is_required: "الدولة مطلوية",
          city: "المدينة",
          city_is_required: "المدينة مطلوبة",
          landline_phone: "الهاتف",
          // landline_phone_is_required: "الهاتف مطلوب",
          mail: "الايميل",
          please_enter_a_valid_mail: "يرجى إدخال بريد إلكتروني صالح (مثال: example@domain.com)",
          phone_number_is_required: "الرجاء ادخال رقم موبايل",
          fields_of_medical_interest: "مجالات الاهتمام الطبي",
          medical_interests: "الاهتمامات الطبية",
          please_select_at_least_one_area_of_interest: "الرجاء اختيار واحدة على الاقل من  مجالات الاهتمام",
          other_interest: "اهتمامات أخرى",
          how_did_you_hear_about_us: "كيف علمت بالفعالية",
          heard_about_us: "علمت عن الفعالية من ..",
          please_select_one_of_how_did_you_hear_about_us: "الرجاء اختيار واحدة من قائمة التعرف",
          other_hear_about_us: "طرق أخرى",
          other_heard_about_us_is_required: "طريقة اخرى سمعت بها عن المؤتمر",
          please_check_your_email: "الرجاء التحقق من البريد الالكتروني",
          submit: "تسجيل",
          submitting: "جاري التسجيل",
          who_are_we: "من نحن",
          description: `هي أكاديمية بريطانية متخصصة في طب الأسنان، رائدة في ابتكار مستقبل التعليم الطبي من خلال برامج تدريبية عملية عالية الجودة قائمة على الأدلة العلمية،`,
          contact_us: "اتصل بنا",
          location: "دمشق, سوريا",
          copyright: "حقوق النشر",
          developed: "تم تطويره من قبل AIGate. جميع الحقوق محفوظة",
          events: "الفعاليات",
          please_select_at_least_one_of_events: "الرجاء اختيار واحدة على الاقل من الفعاليات",
          start_time: "وقت البدء",
          end_time: "وقت الانتهاء",
          event_location: "مكان الفعالية",
          price: "السعر",
        }
      }
    },
    interpolation: {
      escapeValue: false,
    }
  });

export default i18n;
